/* Brand tokens — replace THIS FILE to re-skin for another Capabilia brand.
   Never hardcode colors/fonts/logo in components; consume these tokens. */
export const brand = {
  siteName: "Córdoba Crea Futuro",
  productName: "Talento",
  wordmarkTop: "CÓRDOBA",
  wordmarkBottom: "CREA FUTURO",
  colors: {
    primary: "#172c3f",
    primaryHover: "#0d1a26",
    secondary: "#274e70",
    accent: "#009cde",
    accentHover: "#80bfff",
    dark: "#060a10",
    bg: "#ffffff",
    surface: "#f8fafc",
    chipBorder: "#274e70",
    textMuted: "#808080",
  },
  fonts: { heading: "'Spartan', 'Montserrat', sans-serif", body: "'Poppins', sans-serif" },
  nav: [
    { label: "Inicio", to: "/" },
    { label: "Institucional", href: "https://www.cordobacreafuturo.com.ar" },
    { label: "Programas", href: "https://www.cordobacreafuturo.com.ar" },
    { label: "Bolsa de Talentos", to: "/empleos" },
    { label: "Comunidad", to: "/comunidad", feature: "comunidad" },
    { label: "Vidriera", to: "/vidriera" },
  ],
  academias: ["Córdoba Crea Futuro", "UIC", "FEDECOM", "AREANDINA", "Siglo 21"],
};
